import cashJournalReport from '../features/journals/journalReports/cashJournal/cashJournal';
import CommissionJournal from '../features/journals/journalReports/commissionJournal/commissionJournal';
import GeneralJournal from '../features/journals/journalReports/generalJournal/generalJournal';
import salesJournalReport from '../features/journals/journalReports/salesJournal/salesJournal';
import trustJournal from '../features/journals/journalReports/trustJournal/trustJournal';
import ArAdjustmentReport from '../features/reports/generateReport/reportTable/arAdjustmentReport/arAdjustmentReport';
import ARAgingDetailedReportTable from '../features/reports/generateReport/reportTable/arAegingDetailedReport/arAegingDetailedReport';
import ARAgingReportTable from '../features/reports/generateReport/reportTable/arAgingReport/arAgingReport';
import EquityOnCancelledContract from '../features/reports/generateReport/reportTable/equityOnCancelledContract/equityOnCancelledContract';
import FutureDeedReport from '../features/reports/generateReport/reportTable/FutureDeedReport/FutureDeedReport';
import InterestAndFinancebyCustomerReportTable from '../features/reports/generateReport/reportTable/interestAndFinancebyCustomerReport/interestAndFinancebyCustomerReportTable';
import NegativeDueReport from '../features/reports/generateReport/reportTable/negativeDueReport/negativeDueReport';
import OverDueExceptionReport from '../features/reports/generateReport/reportTable/overDueExceptionReport/overDueExceptionReport';
import PayOffReport from '../features/reports/generateReport/reportTable/PayOffReport/PayOffReport';
import PiaExceptionReport from '../features/reports/generateReport/reportTable/piaExceptionReport/piaExceptionReportTable';
import PNFuneralTrustAgingDetailed from '../features/reports/generateReport/reportTable/pnFuneralTrustAgingDetailed/pnFuneralTrustAgingDetailed';
import PNFuneralTrustAgingSummary from '../features/reports/generateReport/reportTable/pnFuneralTrustAgingSummary/pnFuneralTrustAgingSummary';
import UnpaidTransactionReportTable from '../features/reports/generateReport/reportTable/unpaidTransactionReport/unpaidTransactionReportTable';

export const components = {
  arAgingReport: {
    component: ARAgingReportTable,
    type: 1,
    pagination: false,
  },
  arAgingDetailedReport: {
    component: ARAgingDetailedReportTable,
    type: 1,
    pagination: true,
  },
  pnFuneralTrustAgingSummary: {
    component: PNFuneralTrustAgingSummary,
    type: 1,
    pagination: false,
  },
  pnFuneralTrustAgingDetailedReport: {
    component: PNFuneralTrustAgingDetailed,
    type: 1,
    pagination: true,
  },
  futurePaidinFullReport: {
    component: FutureDeedReport,
    type: 2,
    pagination: true,
  },
  payOffReport: {
    component: PayOffReport,
    type: 3,
    pagination: true,
  },
  interestAndFinancebyCustomer: {
    component: InterestAndFinancebyCustomerReportTable,
    type: 2,
    pagination: true,
  },
  equityOnCancelledContract: {
    component: EquityOnCancelledContract,
    type: 2,
    pagination: true,
  },
  unpaidTransactionReport: {
    component: UnpaidTransactionReportTable,
    type: 2,
    pagination: true,
  },
  arAdjustmentReport: {
    component: ArAdjustmentReport,
    type: 2,
    pagination: true,
  },
  salesJournal: {
    component: salesJournalReport,
    type: 2,
    pagination: true,
    title: 'Sales Journal',
  },
  cashJournal: {
    component: cashJournalReport,
    type: 2,
    pagination: true,
    title: 'Cash Journal',
  },
  commissionJournal: {
    component: CommissionJournal,
    type: 2,
    pagination: true,
    title: 'Commission Journal',
  },
  generalJournal: {
    component: GeneralJournal,
    type: 2,
    pagination: true,
    title: 'General Journal',
  },
  trustJournal: {
    component: trustJournal,
    type: 2,
    pagination: true,
    title: 'Trust Journal',
  },
  PIAExceptionReport: {
    component: PiaExceptionReport,
    type: 3,
    pagination: true,
  },
  negativeDueReport: {
    component: NegativeDueReport,
    type: 1,
    pagination: true,
  },
  pastDueReport: {
    component: OverDueExceptionReport,
    type: 2,
    pagination: true,
  },
};
